// Maps common terms to potentially relevant S2 workflow icons.
export const iconAliases = {
  'add': ['New', 'ProjectCreate'],
  'again': ['Redo'],
  'annotation': ['MusicNote', 'StickyNote'],
  'arrow': ['ChevronDoubleLeft', 'ChevronDoubleRight', 'ChevronDown', 'ChevronLeft', 'ChevronRight', 'ChevronUp'],
  'attention': ['AlertDiamond', 'AlertTriangle'],
  'audio': ['MusicNote', 'VolumeOff', 'VolumeOne', 'VolumeTwo'],
  'begin': ['Play'],
  'browser': ['WebNavBar', 'WebPage'],
  'call': ['DevicePhone'],
  'camera': ['Image', 'ImageAdd', 'ImageBackgroundRemove'],
  'cancel': ['Close', 'CloseCaptions', 'CloseCircle'],
  'caret': ['ArrowHeadTool', 'ChevronDoubleLeft', 'ChevronDoubleRight', 'ChevronDown', 'ChevronLeft', 'ChevronRight', 'ChevronUp'],
  'chat': ['Comment', 'CommentCheckmark', 'CommentHide', 'CommentRemove', 'CommentShow', 'CommentText', 'TextReplaceComment'],
  'chevron': ['ArrowHeadTool'],
  'clockwise': ['RotateCW'],
  'close': ['Cancel'],
  'comment': ['Feedback'],
  'confirm': ['CheckBox'],
  'connection': ['SocialNetwork'],
  'conversation': ['Chat'],
  'copy': ['Duplicate'],
  'counterclockwise': ['RotateCCW'],
  'create': ['Add', 'AddCircle', 'AddContent', 'CalendarAdd', 'DataAdd', 'FileAdd', 'FolderAdd', 'ImageAdd', 'New', 'ProjectAddInto', 'TextAdd', 'UserAdd'],
  'date': ['Calendar', 'CalendarAdd', 'CalendarDay', 'CalendarEdit', 'CalendarWeek'],
  'decrease': ['ChevronDown', 'OrderOneDown', 'SortDown', 'ThumbDown'],
  'delete': ['CommentRemove', 'ImageBackgroundRemove', 'RemoveCircle'],
  'developer': ['Code'],
  'diagram': ['ChartBarVert', 'ChartPie', 'ChartTrend'],
  'directory': ['Folder', 'FolderAdd', 'FolderBreadcrumb', 'FolderClock', 'FolderMoveTo', 'FolderOpen', 'FolderSearch'],
  'display': ['ViewGrid', 'ViewGridFluid', 'ViewList', 'ViewTransparency'],
  'doc': ['File', 'FileAdd', 'FileConvert', 'FileText', 'FileUser'],
  'document': ['File', 'FileAdd', 'FileConvert', 'FileText', 'FileUser'],
  'download': ['SaveFloppy'],
  'duplicate': ['Copy'],
  'edit': ['PenBrush'],
  'end': ['Cancel', 'Close', 'CloseCaptions', 'CloseCircle'],
  'enlarge': ['ZoomIn', 'ZoomOut'],
  'eye': ['ViewGrid', 'ViewGridFluid', 'ViewList', 'ViewTransparency'],
  'favorite': ['Heart', 'Star', 'StarFilled'],
  'feedback': ['Comment', 'CommentCheckmark', 'CommentHide', 'CommentRemove', 'CommentShow', 'CommentText', 'TextReplaceComment'],
  'film': ['MovieCamera', 'Video'],
  'find': ['FolderSearch', 'Search'],
  'finish': ['Close', 'CloseCaptions', 'CloseCircle'],
  'funnel': ['Filter'],
  'gear': ['DataSettings', 'Settings', 'TextVariableFontSettings', 'UserSettings'],
  'graph': ['ChartBarVert', 'ChartPie', 'ChartTrend'],
  'horizontal': ['RectangleHoriz', 'UnlinkHoriz'],
  'house': ['Home'],
  'image': ['Camera', 'CameraProperties', 'MovieCamera'],
  'increase': ['ChevronUp', 'OrderOneUp', 'SortUp', 'ThumbUp'],
  'information': ['InfoCircle'],
  'insert': ['Add', 'AddCircle', 'AddContent', 'CalendarAdd', 'DataAdd', 'FileAdd', 'FolderAdd', 'ImageAdd', 'New', 'ProjectAddInto', 'ProjectCreate', 'TextAdd', 'UserAdd'],
  'internet': ['WebNavBar', 'WebPage'],
  'keyboard': ['Key'],
  'label': ['Tag'],
  'like': ['Heart'],
  'list': ['MenuHamburger'],
  'location': ['PinOff', 'PinOn'],
  'lookup': ['FindAndReplace', 'FolderSearch', 'Search'],
  'love': ['Heart'],
  'lower': ['ChevronDown', 'OrderOneDown', 'SortDown', 'ThumbDown'],
  'magnify': ['FolderSearch', 'Search', 'ZoomIn', 'ZoomOut'],
  'map': ['Location', 'PinOff', 'PinOn'],
  'marker': ['Flag'],
  'member': ['FileUser', 'User', 'UserAdd', 'UserAvatar', 'UserAvatarCursor', 'UserEdit', 'UserFollowing', 'UserGroup', 'UserLock', 'UserSettings'],
  'menu': ['ListBulleted', 'ListMultiSelect', 'ListNumbered', 'ViewList'],
  'message': ['Chat', 'Comment', 'CommentCheckmark', 'CommentHide', 'CommentRemove', 'CommentShow', 'CommentText', 'TextReplaceComment'],
  'minus': ['CommentRemove', 'Delete', 'ImageBackgroundRemove', 'RemoveCircle'],
  'modify': ['CalendarEdit', 'Edit', 'EditNo', 'UserEdit'],
  'movie': ['Video'],
  'music': ['AudioWave'],
  'network': ['CloudStateSlowConnection', 'SlowConnectionCircle'],
  'new': ['Add', 'AddCircle', 'AddContent', 'CalendarAdd', 'DataAdd', 'FileAdd', 'FolderAdd', 'ImageAdd', 'ProjectAddInto', 'ProjectCreate', 'TextAdd', 'UserAdd'],
  'next': ['StepForward'],
  'online': ['Cloud', 'CloudStateDisconnected', 'CloudStateError', 'CloudStateInProgress', 'CloudStatePaused', 'CloudStatePending', 'CloudStateSlowConnection', 'UploadToCloud'],
  'options': ['DataSettings', 'PluginGear', 'Settings', 'TextVariableFontSettings', 'UserSettings'],
  'padlock': ['Lock', 'LockOpen', 'UserLock', 'UsersLock'],
  'person': ['FileUser', 'User', 'UserAdd', 'UserAvatar', 'UserAvatarCursor', 'UserEdit', 'UserFollowing', 'UserGroup', 'UserLock', 'UserSettings'],
  'phone': ['CallCenter'],
  'photo': ['Camera', 'CameraProperties', 'Image', 'ImageAdd', 'ImageBackgroundRemove', 'MovieCamera'],
  'picture': ['Camera', 'CameraProperties', 'Image', 'ImageAdd', 'ImageBackgroundRemove', 'MovieCamera'],
  'pin': ['Location'],
  'place': ['Location'],
  'plus': ['Add', 'AddCircle', 'AddContent', 'CalendarAdd', 'DataAdd', 'FileAdd', 'FolderAdd', 'ImageAdd', 'New', 'ProjectAddInto', 'TextAdd', 'UserAdd'],
  'profile': ['FileUser', 'User', 'UserAdd', 'UserAvatar', 'UserAvatarCursor', 'UserEdit', 'UserFollowing', 'UserGroup', 'UserLock', 'UserSettings'],
  'program': ['Code'],
  'raise': ['ChevronUp', 'OrderOneUp', 'SortUp', 'TextIncrease', 'ThumbUp'],
  'reload': ['DataRefresh', 'Refresh'],
  'remove': ['Delete'],
  'repeat': ['Redo'],
  'reverse': ['Undo'],
  'save': ['Download'],
  'schedule': ['Calendar', 'CalendarAdd', 'CalendarDay', 'CalendarEdit', 'CalendarWeek'],
  'script': ['Code'],
  'search': ['FindAndReplace'],
  'secure': ['Lock', 'LockOpen', 'UserLock', 'UsersLock'],
  'send': ['DataUpload', 'Share', 'ShareAndroid', 'Upload', 'UploadToCloud'],
  'settings': ['PluginGear'],
  'share': ['Send'],
  'sound': ['AudioWave', 'MusicNote', 'VolumeOff', 'VolumeOne', 'VolumeTwo'],
  'start': ['Play'],
  'stop': ['Cancel', 'Close', 'CloseCaptions', 'CloseCircle', 'Pause', 'PauseCircle'],
  'store': ['SaveFloppy'],
  'subtract': ['CommentRemove', 'Delete', 'ImageBackgroundRemove', 'RemoveCircle'],
  'telephone': ['CallCenter', 'DevicePhone'],
  'tick': ['CheckBox'],
  'time': ['Clock', 'ClockPending', 'FolderClock'],
  'trash': ['Delete'],
  'unlock': ['FolderOpen', 'LockOpen', 'OpenIn'],
  'up': ['TextIncrease'],
  'versus': ['Compare'],
  'vertical': ['ChartBarVert'],
  'video': ['MovieCamera'],
  'volume': ['AudioWave'],
  'vs': ['Compare'],
  'warning': ['AlertDiamond', 'AlertTriangle', 'CloudStateError'],
  'watch': ['Clock', 'ClockPending', 'FolderClock'],
  'wifi': ['SocialNetwork'],
  'wireless': ['SocialNetwork'],
  'write': ['CalendarEdit', 'Edit', 'EditNo', 'PenBrush', 'UserEdit']
};
